/// <amd-module name="VC/Common/Components/VersionDropdownAsync" />
import * as React from 'react';

import { Components, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";

import { VersionDropdown } from "./VersionDropdown";
import { IVersionDropdownProps } from "./VersionDropdown.Props";

import { GitRepository } from "../Contracts/Git";
import { IDeprecatedGitRepositoryService } from "../GitRepositoryService";

import { Spinner } from "VSSUI/Spinner";

export interface IVersionDropdownAsyncProps {
    repositoryId: string;
    projectId?: string;
    versionDropdownProps: IVersionDropdownProps;
}

interface IVersionDropdownAsyncState {
    gitRepository?: GitRepository;
}

export class VersionDropdownAsync extends VssComponent<IVersionDropdownAsyncProps, IVersionDropdownAsyncState> {
    constructor(props: IVersionDropdownAsyncProps, context: IVssComponentContext) {
        super(props, context);
        this.state = {};
    }

    public componentDidMount() {
        super.componentDidMount();
        if (!this.state.gitRepository) {
            this._fetchGitRepository();
        }
    }

    public render(): JSX.Element {
        const providerOptions = { ...this.props.versionDropdownProps.providerOptions, repository: this.state.gitRepository || {} };
        const props = { ...this.props.versionDropdownProps, providerOptions };
        return (
            <>
                {this.state.gitRepository
                    ? (<VersionDropdown {...props} />)
                    : (<Spinner />)
                }
            </>
        );
    }

    private _fetchGitRepository() {
        const gitRepositoryService = this.context.pageContext.getService<IDeprecatedGitRepositoryService>("IDeprecatedGitRepositoryService");
        gitRepositoryService.getRepositoryById(this.props.repositoryId, this.props.projectId)
            .then((gitRepository: GitRepository) => {
                this.setState({ gitRepository });
            });
    }
}

Components.add("version-dropdown-async", VersionDropdownAsync);
